import React from 'react'
import Box from '@material-ui/core/Box'

interface Props {
  value?: number
}
export default function Separate(props: Props) {
  return <Box pt={props.value ? props.value : 1} />
}
